export default "__VITE_ASSET__ff40116a__"